import React, { useEffect, useMemo } from 'react'
import { Box, TextField, Button, Grid,
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { updateStudentDetails } from 'services/students';

const EditUser = ({ userData, onSuccess, onFailure }) => {

  const defaultFormFields = useMemo(() => ({
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
  }),[]);

 
  const { enqueueSnackbar } = useSnackbar();

  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  useEffect(() => {
    if(userData){
      const data = {
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        mobile: userData?.mobile,
        email: userData?.email,
      }
      reset({...data});
    }
  }, [userData, reset]);

  const resetForm = () => {
    reset({...defaultFormFields});
  };

  const onSubmit = (data) => {
    saveUserDetails(data);
  }

  const saveUserDetails = (data) => {
    updateStudentDetails({
      ...data,
      ...(userData?.userId ? {userId: userData?.userId} : {})
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Student updated successfully`), {variant: 'success'});
        resetForm();
        onSuccess()
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      }
    });
  }


  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">
        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="firstName"
            id="firstName"
            rules={{ required: "Enter first name" }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="First Name"
                required
                error={!!errors?.firstName}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="lastName"
            id="lastName"
            rules={{ required: "Enter last name" }}
            render={({field}) => (
              <TextField
              {...field}
                margin="normal"
                label="Last Name"
                required
                error={!!errors?.lastName}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="mobile"
            id="mobile"
            rules={{ required: "Enter mobile number",
            pattern: {
              value: /^[0-9]{10}$/i,
              message: "Enter a valid 10 digit registered mobile number",
            },
          }}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Mobile"
                required
                error={!!errors?.mobile}
                helperText={errors.mobile?.message}
                size="small"
                fullWidth
                // InputProps={{
                //   endAdornment: <InputAdornment position="start">%</InputAdornment>,
                // }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="email"
            id="email"
            rules={{ required: "Enter email",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: "Enter a valid email address",
            },
          }}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Email"
                required
                error={!!errors?.email}
                helperText={errors.email?.message}
                size="small"
                fullWidth
                // InputProps={{
                //   endAdornment: <InputAdornment position="start">%</InputAdornment>,
                // }}
              />
            )}
          />
        </Grid>
          
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            startIcon={<ModeEditIcon />}
            color="primary"
          >
            Update
          </Button>
        </Grid>


        </Grid>
    </Box>
  );
}
 
export default React.memo(EditUser);
